import { EmptyComponent } from "./EmptyComponent.js";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { getSVGImagePath } from "./SVGIcon/SVGImagePath.js";
import { ImageIcon } from "./ImageIcon.js";
import { DivIcon } from "./DivIcon.js";

const SVGIconComponent = props => {
  const {
    iconName,
    dataTestId,
    asBackground,
    asImage,
    children = null,
    className,
    ...restProps
  } = props;

  const [path, setPath] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    const loadPath = async () => {
      const svgPath = await getSVGImagePath(iconName);

      // Only update state if the component is still mounted and iconName hasn't changed
      if (!isCancelled) {
        setPath(svgPath);
      }
    };

    if (iconName) {
      void loadPath();
    }

    return () => {
      isCancelled = true;
    };
  }, [iconName]);

  const classes = useMemo(
    () =>
      classNames("svg-icon", `icon-${iconName}`, {
        [className]: !!className
      }),
    [iconName, className]
  );

  if (!iconName || !path) {
    return <EmptyComponent />;
  }

  if (asImage) {
    return (
      <ImageIcon
        {...restProps}
        dataTestId={dataTestId}
        path={path}
        classNames={classes}
        iconName={iconName}
        asImage={asImage}
      >
        {children}
      </ImageIcon>
    );
  }

  return (
    <DivIcon
      {...restProps}
      dataTestId={dataTestId}
      path={path}
      classNames={classes}
      iconName={iconName}
      asBackground={asBackground}
    >
      {children}
    </DivIcon>
  );
};

SVGIconComponent.propTypes = {
  iconName: PropTypes.string,
  dataTestId: PropTypes.string.isRequired,
  children: PropTypes.any,
  asBackground: PropTypes.bool,
  asImage: PropTypes.bool,
  className: PropTypes.string
};

export const SVGIcon2 = React.memo(SVGIconComponent);
